import { gql, OperationVariables, useLazyQuery } from "@apollo/client"
import { DownloadLink } from "@oysterhr/schema"
import { useQuery } from "@oysterhr/core"
import DownloadLinkFields from "./fragments/DownloadLinkFields"

const QUERY = gql`
  query DocumentDownloadLink($documentId: ID!, $disposition: ContentDisposition) {
    documentDownloadLink(documentId: $documentId, disposition: $disposition) {
      ...DownloadLinkFields
    }
  }
  ${DownloadLinkFields}
`

export default (variables: OperationVariables, skip?: boolean) =>
  useQuery<{ documentDownloadLink: DownloadLink }>(QUERY, {
    variables,
    skip,
    fetchPolicy: "no-cache",
  })

export const useLazyDocumentDownloadLink = (variables?: OperationVariables) => {
  return useLazyQuery<{ documentDownloadLink: DownloadLink }>(QUERY, {
    variables,
    fetchPolicy: "no-cache",
  })
}
